<script>
import Vue from "vue";
import api from '@/helpers/apirest/api';

export default {
  emits: ['onSuccess', 'onError'],
  props: {
    advantage:{
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false
    };
  },
  components: {
  },
  methods: {
    async sync(){
      try {

        const result = await Vue.swal({
          title: "Sincronizar ventaja",
          icon: "info",
          html:  "Seguro que desea sincronizar la ventaja?",
          showCloseButton: false,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: 'Sí',
          cancelButtonText: 'Cancelar',
        });

        if (result.value) {
          let endPoint = `advantages/${this.advantage?.id}/sync-eyca`;
          this.loading = true;

          try {
            await api.post({
                url: endPoint,
                config: {
                    withLoading: true
                }                
            });
            this.loading = false;
            this.$emit('onSuccess');

            Vue.swal({
                position: "top-end",
                icon: "success",
                title: "Acción ejecutada con exito",
                showConfirmButton: false,
                timer: 2000
            });
          } catch (error) {
            this.loading = false;
            this.$emit('onError');
          }
        }
        
      }
      catch (error) {
          console.log(error);
      }
    }
  }
};
</script>

<template>
  <span>
    <i 
      v-if="!advantage?.eyca_sync_error && !advantage?.eyca_external_id && !loading"
      class="mdi mdi-sync-circle font-size-18 pointer text-default"
      :title="'Click para sincronizar la ventaja'"
      v-b-tooltip.hover
      @click="sync()"
    ></i> 
    <i 
      v-else-if="!advantage?.eyca_sync_error && advantage?.eyca_external_id && !loading"
      class="mdi mdi-sync-circle font-size-18 pointer text-primary"
      :title="'Ventaja sincronizada. Click para sincronizar nuevamente'"
      v-b-tooltip.hover
      @click="sync()"
    ></i> 
    <i 
      v-else-if="advantage?.eyca_sync_error && !loading"
      class="mdi mdi-sync-circle font-size-18 pointer text-danger"
      :title="'Error al sincronizar la ventaja. Click para sincronizar nuevamente. ' + advantage?.eyca_sync_error"
      v-b-tooltip.hover
      @click="sync()"
    ></i> 
    <i 
      v-if="loading"
      class="text-primary spinner-border spinner-border-sm"
      :title="'Sincronizando...'"
      v-b-tooltip.hover
    ></i> 
  </span>
</template>